export const LOCAL_STORAGE = 'localStorage'
export const SESSION_STORAGE = 'sessionStorage'

export const checkWindowProp = (key: string): boolean => {
  try {
    return !!window[key]
  } catch (e) {
    return false
  }
}

/** iOS Private Browsing causes Storage API to appear, but to fail with an exception if used */
export const checkStorageEnabled = (storage: Storage): boolean => {
  try {
    const testKey = '_nf_storage'
    storage.setItem(testKey, '0')
    storage.removeItem(testKey)
    return true // if we get here, storage hasn't been disabled
  } catch (e) {
    // If you couldn't write to storage above but it isn't empty (length > 0), it may actually be full.
    // If this is the case, then we want to return true so we can at least get things out of it.
    return storage.length > 0
  }
}

export const referringHostname = (): string => {
  let hostname = window.location.hostname
  if (window.location.port.length > 0) hostname = `${hostname}:${window.location.port}`
  return hostname
}

export default class Capabilities {
  private constructor() {
    // Static class
  }

  static cookiesEnabled(): boolean {
    return window.navigator.cookieEnabled
  }

  static hasStorage(): boolean {
    return checkWindowProp(LOCAL_STORAGE) && checkStorageEnabled(window.localStorage)
  }

  static hasSessionStorage(): boolean {
    return checkWindowProp(SESSION_STORAGE) && checkStorageEnabled(window.sessionStorage)
  }

  static storageDisabled(): boolean {
    return checkWindowProp(LOCAL_STORAGE) && !checkStorageEnabled(window.localStorage)
  }
}
